import { Button } from '../../../components/ui/button';
import { GalleryBlock, GiftsBlock, LocationBlock, RsvpBlock, SiteFooter, StoryBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

export default function MinimalClassicTemplate(props) {
  const {
    site,
    theme,
    weddingDateLabel,
    daysUntil,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showCountdown,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const galleryNode = (
    <GalleryBlock
      galleryImages={site.gallery_images}
      headingFont={theme.headingFont}
      titleColor={theme.galleryTitleColor || theme.primaryColor}
      secondaryColor={theme.galleryIconColor || theme.secondaryColor}
      sectionBackground={theme.gallerySectionBackground}
      onOpenGallery={onOpenGallery}
      cardClass="rounded-md"
    />
  );

  return (
    <>
      <section className="min-h-[72vh] px-6 py-16 flex items-center" style={{ background: theme.bannerSectionBackground || '#FFFFFF' }}>
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-[0.68rem] uppercase tracking-[0.35em]" style={{ color: theme.bannerTextColor || '#7B7B7B', fontFamily: theme.bannerTextFont }}>Minimal Classic</p>
          <h1 className="mt-6 text-5xl md:text-7xl leading-tight" style={{ color: theme.heroTitleColor, fontFamily: theme.bannerTitleFont }}>
            {site.couple_names}
          </h1>
          <p className="mt-4 text-lg" style={{ color: theme.bannerTextColor || theme.heroDateColor, fontFamily: theme.bannerTextFont }}>{weddingDateLabel}</p>
          {showCountdown ? <p className="mt-6 text-sm uppercase tracking-[0.25em]" style={{ color: theme.primaryColor }}>{daysUntil} dias</p> : null}
          <Button
            onClick={() => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.())}
            className="mt-8 h-11 rounded-none px-10"
            style={{ background: theme.confirmButtonBackground, color: theme.confirmButtonText, borderColor: theme.confirmButtonBorder, borderWidth: 1, borderStyle: 'solid' }}
          >
            Confirmar Presença
          </Button>
        </div>
      </section>

      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}

      <StoryBlock
        title="Nossa História"
        storyText={site.story_text}
        background={theme.storySectionBackground || '#FAFAFA'}
        titleColor={theme.storyTitleColor}
        bodyColor={theme.storyBodyColor}
        titleFont={theme.storyTitleFont}
        bodyFont={theme.storyBodyFont}
        compact
      />

      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}

      <LocationBlock
        locationCards={locationCards}
        headingFont={theme.headingFont}
        titleFont={theme.locationTitleFont || theme.headingFont}
        titleColor={theme.locationTitleColor}

        textColor={theme.locationTextColor}
        textFont={theme.locationTextFont}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.locationSectionBackground || '#F8F6F4'}
        sectionIconColor={theme.locationIconColor || theme.locationTitleColor}
        cardBackground={theme.locationCardBackground}
        cardIconBackground={theme.locationIconColor || theme.locationTitleColor}
        cardTitleColor={theme.locationTitleColor}
        cardLinkColor={theme.locationIconColor || theme.locationTitleColor}
        cardClass="rounded-none border border-slate-200 bg-white"
      />

      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor={theme.primaryColor}
        textColor={theme.bodyTextColor}
        secondaryColor={theme.secondaryColor}
        onGiftClick={onGiftClick}
        compact
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor={theme.primaryColor}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.rsvpSectionBackground}
        buttonBackground={theme.confirmButtonBackground}
        buttonText={theme.confirmButtonText}
        buttonBorder={theme.confirmButtonBorder}
        iconColor={theme.rsvpIconColor || theme.rsvpTextColor || theme.bodyTextColor}
        titleColor={theme.rsvpTextColor || theme.bodyTextColor}
        bodyColor={theme.rsvpTextColor || theme.bodyTextColor}
        countColor={theme.rsvpTextColor || theme.bodyTextColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <SiteFooter coupleNames={site.couple_names} textColor={theme.bodyTextColor} />
    </>
  );
}

